import { css } from '@emotion/react';
import Skeleton from 'react-loading-skeleton';

import { SasIcon } from '../SasIcon';
import { theme } from '../theme';

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: ${theme.spacing.md};
  `,
  city: css`
    margin-right: 5px;
    font-weight: ${theme.fontWeight.normal};
    color: ${theme.colors.blue[3]};
    text-transform: none;
    margin-bottom: 0;
    margin-top: 0;

    @media (max-width: ${theme.breakpoints.laptop}) {
      font-size: 20px;
    }
  `,
  airport: css`
    margin: 0;
    margin-bottom: 0;
    font-weight: ${theme.fontWeight.black};
    color: ${theme.colors.blue[3]};

    @media (max-width: ${theme.breakpoints.laptop}) {
      font-size: 20px;
    }
  `,
  icon: css`
    display: flex;
    margin: 0 ${theme.spacing.sm};

    svg {
      scale: 1.2;
    }
  `,
};

type Props = {
  from?: {
    cityName: string;
    airportCode: string;
  };
  to?: {
    cityName: string;
    airportCode: string;
  };
  className?: string;
  isLoading?: boolean;
};

export function BoundTitle({ from, to, className, isLoading = false }: Props) {
  if (isLoading) {
    return (
      <h2 css={styles.wrapper} className={className}>
        <Skeleton style={{ width: 140, display: 'inline-block' }} />
        <SasIcon name="cl--plane-right" css={styles.icon} color={theme.colors.blue[3]} />
        <Skeleton style={{ width: 140, display: 'inline-block' }} />
      </h2>
    );
  }

  if (!from || !to) return null;

  return (
    <h2 css={styles.wrapper} className={className}>
      <span css={styles.city}>{from.cityName}</span>
      <span css={styles.airport}>{from.airportCode}</span>
      <SasIcon name="cl--plane-right" css={styles.icon} color={theme.colors.blue[3]} />
      <span css={styles.city}>{to.cityName}</span>
      <span css={styles.airport}>{to.airportCode}</span>
    </h2>
  );
}
